// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

window.imageScaleAnimation = function imageScaleAnimation() {
  const imageScaleElsArr = document.querySelectorAll(
    '[data-image-scale-animation]'
  );

  if (imageScaleElsArr.length) {
    imageScaleElsArr.forEach((el) => {
      if (!el.classList.contains('is-init')) {
        el.classList.add('is-init');

        let startY = 100;
        let endY = 20;

        let startTrigger = 90;
        let endTrigger = 10;

        if (el.hasAttribute('data-image-scale-animation-later-start')) {
          startTrigger = 70;
          endTrigger = 5;
          endY = 0;
        }

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: el,
            start: `top-=${startY}vh ${startTrigger}%`,
            end: `bottom+=${endY}vh ${endTrigger}%`,
            scrub: 0.85,
            // markers: true,
            invalidateOnRefresh: true,
            /*onUpdate: (self) => {
              const progress = self.progress;
            },*/
          },
        });

        if (el.hasAttribute('data-image-fade-scale-animation')) {
          tl.fromTo(
            el,
            {
              scale: 0.9,
              opacity: 0,
              filter: 'blur(20px)',
            },
            {
              scale: 1,
              duration: 0.6,
              ease: 'power2.out',
            }
          );

          tl.to(
            el,
            {
              opacity: 1,
              filter: 'blur(0px)',
              duration: 0.35,
              ease: 'power2.out',
            },
            '<'
          );
        } else {
          tl.fromTo(
            el,
            {
              opacity: 0,
              scale: 0.9,
              filter: 'blur(20px)',
            },
            {
              opacity: 1,
              scale: 1,
              duration: 0.6,
              filter: 'blur(0px)',
              ease: 'power2.out',
            }
          );
        }
      }
    });
  }
};

imageScaleAnimation();
